import { defineMessages } from 'react-intl'

const messages = defineMessages({
  general_keywords_KZ: {
    id: 'page.general_keywords_KZ',
    defaultMessage: 'букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн казахстан ставки букмекерская контора ставки кз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора казахстан букмекерские конторы казахстана онлайн официальный букмекер казахстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в казахстане ставки на спорт в казахстане букмекерская контора онлайн ставки на спорт бк в казахстане',
  },
  general_description_KZ: {
    id: 'page.general_description_KZ',
    defaultMessage: 'Онлайн ставки на спорт в Казахстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты ',
  },
  general_page_title_KZ: {
    id: 'page.general_page_title_KZ',
    defaultMessage: 'Ставки на спорт онлайн - Букмекерская контора {companyName} в Казахстане',
  },
  general_keywords_KG: {
    id: 'page.general_keywords_KG',
    defaultMessage: 'букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Кыргызстан ставки букмекерская контора ставки кг букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кг интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кг букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Кыргызстан букмекерские конторы Кыргызстана онлайн официальный букмекер Кыргызстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Кыргызстане ставки на спорт в Кыргызстане букмекерская контора онлайн ставки на спорт бк в Кыргызстане',
  },
  general_description_KG: {
    id: 'page.general_description_KG',
    defaultMessage: 'Онлайн ставки на спорт в Кыргызстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кг 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты',
  },
  general_page_title_KG: {
    id: 'page.general_page_title_KG',
    defaultMessage: 'Ставки на спорт онлайн - Букмекерская контора {companyName} в Кыргызстане',
  },
  general_page_title_UZ: {
    id: 'page.general_page_title_UZ',
    defaultMessage: 'Ставки на спорт онлайн - Букмекерская контора {companyName} в Узбекистане',
  },
  general_description_UZ: {
    id: 'page.general_description_UZ',
    defaultMessage: 'Онлайн ставки на спорт в Узбекистане ➤ Официальный сайт легальной букмекерской конторы {companyName} уз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты ',
  },
  general_keywords_UZ: {
    id: 'page.general_keywords_UZ',
    defaultMessage: 'букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Узбекистан ставки букмекерская контора ставки уз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер уз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн уз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Узбекистан букмекерские конторы Узбекистана онлайн официальный букмекер Узбекистан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Узбекистане ставки на спорт в Узбекистане букмекерская контора онлайн ставки на спорт бк в Узбекистане',
  },
  live_page_title_KZ: {
    id: 'page.live_page_title_KZ',
    defaultMessage: 'Лайв ставки на спорт в букмекерской конторе {companyName}',
  },
  live_page_description_KZ: {
    id: 'page.live_page_description_KZ',
    defaultMessage: 'Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк РингоБет в Казахстане',
  },
  live_page_keywords_KZ: {
    id: 'page.live_page_keywords_KZ',
    defaultMessage: 'live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня',
  },
  live_page_title_KG: {
    id: 'page.live_page_title_KG',
    defaultMessage: 'Лайв ставки на спорт в букмекерской конторе {companyName}',
  },
  live_page_description_KG: {
    id: 'page.live_page_description_KG',
    defaultMessage: 'Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  live_page_keywords_KG: {
    id: 'page.live_page_keywords_KG',
    defaultMessage: 'live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня',
  },
  live_page_title_UZ: {
    id: 'page.live_page_title_UZ',
    defaultMessage: 'Лайв ставки на спорт в букмекерской конторе {companyName}',
  },
  live_page_description_UZ: {
    id: 'page.live_page_description_UZ',
    defaultMessage: 'Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Узбекистане',
  },
  live_page_keywords_UZ: {
    id: 'page.live_page_keywords_UZ',
    defaultMessage: 'live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня',
  },
  sports_2_title_KZ: {
    id: 'page.sports_2_title_KZ',
    defaultMessage: 'Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_2_description_KZ: {
    id: 'page.sports_2_description_KZ',
    defaultMessage: 'Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_2_keywords_KZ: {
    id: 'page.sports_2_keywords_KZ',
    defaultMessage: 'настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки',
  },
  sports_4_title_KZ: {
    id: 'page.sports_4_title_KZ',
    defaultMessage: 'Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_4_description_KZ: {
    id: 'page.sports_4_description_KZ',
    defaultMessage: 'Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_4_keywords_KZ: {
    id: 'page.sports_4_keywords_KZ',
    defaultMessage: 'ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве',
  },
  sports_5_title_KZ: {
    id: 'page.sports_5_title_KZ',
    defaultMessage: 'Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_5_description_KZ: {
    id: 'page.sports_5_description_KZ',
    defaultMessage: 'Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_5_keywords_KZ: {
    id: 'page.sports_5_keywords_KZ',
    defaultMessage: 'ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн',
  },
  sports_6_title_KZ: {
    id: 'page.sports_6_title_KZ',
    defaultMessage: 'Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_6_description_KZ: {
    id: 'page.sports_6_description_KZ',
    defaultMessage: 'Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_6_keywords_KZ: {
    id: 'page.sports_6_keywords_KZ',
    defaultMessage: 'live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы',
  },
  sports_7_title_KZ: {
    id: 'page.sports_7_title_KZ',
    defaultMessage: 'Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_7_description_KZ: {
    id: 'page.sports_7_description_KZ',
    defaultMessage: 'Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_7_keywords_KZ: {
    id: 'page.sports_7_keywords_KZ',
    defaultMessage: 'live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня',
  },
  sports_11_title_KZ: {
    id: 'page.sports_11_title_KZ',
    defaultMessage: 'Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_11_description_KZ: {
    id: 'page.sports_11_description_KZ',
    defaultMessage: 'Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_11_keywords_KZ: {
    id: 'page.sports_11_keywords_KZ',
    defaultMessage: 'американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол',
  },
  sports_19_title_KZ: {
    id: 'page.sports_19_title_KZ',
    defaultMessage: 'Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_19_description_KZ: {
    id: 'page.sports_19_description_KZ',
    defaultMessage: 'Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_19_keywords_KZ: {
    id: 'page.sports_19_keywords_KZ',
    defaultMessage: 'ставки на гандбол лайв гандбол онлайн',
  },
  sports_30_title_KZ: {
    id: 'page.sports_30_title_KZ',
    defaultMessage: 'Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_30_description_KZ: {
    id: 'page.sports_30_description_KZ',
    defaultMessage: 'Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_30_keywords_KZ: {
    id: 'page.sports_30_keywords_KZ',
    defaultMessage: 'хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки',
  },
  sports_31_title_KZ: {
    id: 'page.sports_31_title_KZ',
    defaultMessage: 'Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_31_description_KZ: {
    id: 'page.sports_31_description_KZ',
    defaultMessage: 'Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальном сайте бк РингоБет в Казахстане',
  },
  sports_31_keywords_KZ: {
    id: 'page.sports_31_keywords_KZ',
    defaultMessage: 'баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол',
  },
  sports_38_title_KZ: {
    id: 'page.sports_38_title_KZ',
    defaultMessage: 'Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_38_description_KZ: {
    id: 'page.sports_38_description_KZ',
    defaultMessage: 'Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_38_keywords_KZ: {
    id: 'page.sports_38_keywords_KZ',
    defaultMessage: 'лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор',
  },
  sports_39_title_KZ: {
    id: 'page.sports_39_title_KZ',
    defaultMessage: 'Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Казахстане',
  },
  sports_39_description_KZ: {
    id: 'page.sports_39_description_KZ',
    defaultMessage: 'Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк РингоБет в Казахстане',
  },
  sports_39_keywords_KZ: {
    id: 'page.sports_39_keywords_KZ',
    defaultMessage: 'ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в казахстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн',
  },
  sports_2_title_KG: {
    id: 'page.sports_2_title_KG',
    defaultMessage: 'Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_2_description_KG: {
    id: 'page.sports_2_description_KG',
    defaultMessage: 'Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_2_keywords_KG: {
    id: 'page.sports_2_keywords_KG',
    defaultMessage: 'настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки',
  },
  sports_4_title_KG: {
    id: 'page.sports_4_title_KG',
    defaultMessage: 'Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_4_description_KG: {
    id: 'page.sports_4_description_KG',
    defaultMessage: 'Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_4_keywords_KG: {
    id: 'page.sports_4_keywords_KG',
    defaultMessage: 'ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве',
  },
  sports_5_title_KG: {
    id: 'page.sports_5_title_KG',
    defaultMessage: 'Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_5_description_KG: {
    id: 'page.sports_5_description_KG',
    defaultMessage: 'Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_5_keywords_KG: {
    id: 'page.sports_5_keywords_KG',
    defaultMessage: 'ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн',
  },
  sports_6_title_KG: {
    id: 'page.sports_6_title_KG',
    defaultMessage: 'Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_6_description_KG: {
    id: 'page.sports_6_description_KG',
    defaultMessage: 'Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_6_keywords_KG: {
    id: 'page.sports_6_keywords_KG',
    defaultMessage: 'live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы',
  },
  sports_7_title_KG: {
    id: 'page.sports_7_title_KG',
    defaultMessage: 'Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_7_description_KG: {
    id: 'page.sports_7_description_KG',
    defaultMessage: 'Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_7_keywords_KG: {
    id: 'page.sports_7_keywords_KG',
    defaultMessage: 'live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня',
  },
  sports_11_title_KG: {
    id: 'page.sports_11_title_KG',
    defaultMessage: 'Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_11_description_KG: {
    id: 'page.sports_11_description_KG',
    defaultMessage: 'Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_11_keywords_KG: {
    id: 'page.sports_11_keywords_KG',
    defaultMessage: 'американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол',
  },
  sports_19_title_KG: {
    id: 'page.sports_19_title_KG',
    defaultMessage: 'Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_19_description_KG: {
    id: 'page.sports_19_description_KG',
    defaultMessage: 'Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_19_keywords_KG: {
    id: 'page.sports_19_keywords_KG',
    defaultMessage: 'ставки на гандбол лайв гандбол онлайн',
  },
  sports_30_title_KG: {
    id: 'page.sports_30_title_KG',
    defaultMessage: 'Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_30_description_KG: {
    id: 'page.sports_30_description_KG',
    defaultMessage: 'Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_30_keywords_KG: {
    id: 'page.sports_30_keywords_KG',
    defaultMessage: 'хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки',
  },
  sports_31_title_KG: {
    id: 'page.sports_31_title_KG',
    defaultMessage: 'Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_31_description_KG: {
    id: 'page.sports_31_description_KG',
    defaultMessage: 'Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_31_keywords_KG: {
    id: 'page.sports_31_keywords_KG',
    defaultMessage: 'баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол',
  },
  sports_38_title_KG: {
    id: 'page.sports_38_title_KG',
    defaultMessage: 'Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_38_description_KG: {
    id: 'page.sports_38_description_KG',
    defaultMessage: 'Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_38_keywords_KG: {
    id: 'page.sports_38_keywords_KG',
    defaultMessage: 'лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор',
  },
  sports_39_title_KG: {
    id: 'page.sports_39_title_KG',
    defaultMessage: 'Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Кыргызстане',
  },
  sports_39_description_KG: {
    id: 'page.sports_39_description_KG',
    defaultMessage: 'Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Кыргызстане',
  },
  sports_39_keywords_KG: {
    id: 'page.sports_39_keywords_KG',
    defaultMessage: 'ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Кыргызстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн',
  },
  sports_2_title_UZ: {
    id: 'page.sports_2_title_UZ',
    defaultMessage: 'Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_2_description_UZ: {
    id: 'page.sports_2_description_UZ',
    defaultMessage: 'Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_2_keywords_UZ: {
    id: 'page.sports_2_keywords_UZ',
    defaultMessage: 'настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки',
  },
  sports_4_title_UZ: {
    id: 'page.sports_4_title_UZ',
    defaultMessage: 'Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_4_description_UZ: {
    id: 'page.sports_4_description_UZ',
    defaultMessage: 'Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_4_keywords_UZ: {
    id: 'page.sports_4_keywords_UZ',
    defaultMessage: 'ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве',
  },
  sports_5_title_UZ: {
    id: 'page.sports_5_title_UZ',
    defaultMessage: 'Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_5_description_UZ: {
    id: 'page.sports_5_description_UZ',
    defaultMessage: 'Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_5_keywords_UZ: {
    id: 'page.sports_5_keywords_UZ',
    defaultMessage: 'ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн',
  },
  sports_6_title_UZ: {
    id: 'page.sports_6_title_UZ',
    defaultMessage: 'Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_6_description_UZ: {
    id: 'page.sports_6_description_UZ',
    defaultMessage: 'Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_6_keywords_UZ: {
    id: 'page.sports_6_keywords_UZ',
    defaultMessage: 'live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы',
  },
  sports_7_title_UZ: {
    id: 'page.sports_7_title_UZ',
    defaultMessage: 'Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_7_description_UZ: {
    id: 'page.sports_7_description_UZ',
    defaultMessage: 'Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_7_keywords_UZ: {
    id: 'page.sports_7_keywords_UZ',
    defaultMessage: 'live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня',
  },
  sports_11_title_UZ: {
    id: 'page.sports_11_title_UZ',
    defaultMessage: 'Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_11_description_UZ: {
    id: 'page.sports_11_description_UZ',
    defaultMessage: 'Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_11_keywords_UZ: {
    id: 'page.sports_11_keywords_UZ',
    defaultMessage: 'американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол',
  },
  sports_19_title_UZ: {
    id: 'page.sports_19_title_UZ',
    defaultMessage: 'Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_19_description_UZ: {
    id: 'page.sports_19_description_UZ',
    defaultMessage: 'Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_19_keywords_UZ: {
    id: 'page.sports_19_keywords_UZ',
    defaultMessage: 'ставки на гандбол лайв гандбол онлайн',
  },
  sports_30_title_UZ: {
    id: 'page.sports_30_title_UZ',
    defaultMessage: 'Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_30_description_UZ: {
    id: 'page.sports_30_description_UZ',
    defaultMessage: 'Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_30_keywords_UZ: {
    id: 'page.sports_30_keywords_UZ',
    defaultMessage: 'хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки',
  },
  sports_31_title_UZ: {
    id: 'page.sports_31_title_UZ',
    defaultMessage: 'Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_31_description_UZ: {
    id: 'page.sports_31_description_UZ',
    defaultMessage: 'Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_31_keywords_UZ: {
    id: 'page.sports_31_keywords_UZ',
    defaultMessage: 'баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол',
  },
  sports_38_title_UZ: {
    id: 'page.sports_38_title_UZ',
    defaultMessage: 'Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_38_description_UZ: {
    id: 'page.sports_38_description_UZ',
    defaultMessage: 'Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_38_keywords_UZ: {
    id: 'page.sports_38_keywords_UZ',
    defaultMessage: 'лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор',
  },
  sports_39_title_UZ: {
    id: 'page.sports_39_title_UZ',
    defaultMessage: 'Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Узбекистане',
  },
  sports_39_description_UZ: {
    id: 'page.sports_39_description_UZ',
    defaultMessage: 'Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Узбекистане',
  },
  sports_39_keywords_UZ: {
    id: 'page.sports_39_keywords_UZ',
    defaultMessage: 'ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Узбекистане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн',
  },
})

export const getMetadata = (countryCode, sportId, live) => {
  const sportIdsWithMetaData = [2, 4, 5, 6, 7, 11, 19, 30, 31, 38, 39];

  if (sportIdsWithMetaData.includes(parseInt(sportId))) {
    return {
      title: messages[`sports_${sportId}_title_${countryCode}`],
      description: messages[`sports_${sportId}_description_${countryCode}`],
      keywords: messages[`sports_${sportId}_keywords_${countryCode}`],
    }
  } else if (live) {
    return {
      title: messages[`live_page_title_${countryCode}`],
      description: messages[`live_page_description_${countryCode}`],
      keywords: messages[`live_page_keywords_${countryCode}`],
    }
  } else {
    return {
      title: messages[`general_page_title_${countryCode}`],
      description: messages[`general_description_${countryCode}`],
      keywords: messages[`general_keywords_${countryCode}`],
    }
  }
}


// WEBPACK FOOTER //
// ./js/shared/metadata/metadata.js